<ng-container *ngIf="state$ | async as state">
  <button
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    (click)="open$.next(true)"
    mat-button
    class="mat-display-1"
  >
    <fa-icon icon="user"></fa-icon>
    {{ state.loggedInUser?.firstName | titlecase }}
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="(open$ | async) ?? false"
    (overlayOutsideClick)="open$.next(false)"
    (overlayKeydown)="overlayKeyDown($event)"
  >
    <x-overlay-content>
      <x-triangle [target]="trigger"></x-triangle>
      <x-my-account-menu class="p-3 pb-0" (click)="open$.next(false)">
        <button type="button" mat-button xButtonType="link" xNeedHelp color="primary" xAction>
          <fa-icon icon="question"></fa-icon>
          <span i18n="@@CallToAction.NeedHelp">Help</span>
        </button>
      </x-my-account-menu>
    </x-overlay-content>
  </ng-template>
</ng-container>
